<template>
    <div id="analyticsTab" class="wrap">
        <div class="line-item toolbar">
            <div class="left-item"></div>
            <div class="right-item tour-buttons">
                <span>
                    <div class="el"></div>
                    <div class="el"></div>
                    <div class="el">
                        <md-button v-if="_.isEmpty(invalidTours) && !importRunning" class="upload-btn">
                            <form enctype="multipart/form-data" novalidate>
                                <input id="files" class="file-input" type="file" multiple="multiple" @change="processFiles($event)"/>
                            </form>
                            <span>import</span>
                        </md-button>
                        <md-button v-else-if="!_.isEmpty(invalidTours)" class="upload-btn" @click="showWarning()">
                            <span>import</span>
                        </md-button>
                    </div>
                </span>
            </div>
        </div>

        <!--toolbar-->
        <div class="line-item analytics-toolbar">
            <div class="left-item">
                <div class="el">
                    <md-field>
                        <md-select name="analyticsView" v-model="currentView" placeholder="Select Analytics" :change="switchView()">
                            <md-option value="/client/analytics/audience" selected>Audience Overview</md-option>
                            <md-option value="/client/analytics/topic">TOI Sessions</md-option>
                        </md-select>
                    </md-field>
                </div>
            </div>
            <form>
                <div class="right-item">
                    <div class="el">
                        <md-field>
                            <md-select v-model="analytics.tourId" class="half-field" placeholder="Select Tour">
                                <md-option :value="0">All</md-option>
                                <md-option v-for="tour in tours" :value="tour.id" :key="tour.name">{{ tour.name }}</md-option>
                            </md-select>
                        </md-field>
                    </div>
                    <div class="el">
                        <md-field>
                            <md-select v-if="false && this.analytics.tourId && this.analytics.tourId > 0" v-model="analytics.routeId" class="half-field" placeholder="Select Route">
                                <md-option :value="allOption">All</md-option>
                                <md-option v-for="route in routes" :value="route.id" :key="route.name">{{ route.name }}</md-option>
                            </md-select>
                        </md-field>
                    </div>
                    <div v-if="showLanguageDropdown" class="el">
                        <md-field>
                            <md-select v-model="analytics.language" class="half-field" placeholder="Select Language">
                                <md-option :value="allOption">All</md-option>
                                <md-option v-if="analytics.usage && analytics.usage.languages" v-for="language in analytics.usage.languages" :value="language.channelName" :key="language.channelName">{{ language.channelName }}</md-option>
                            </md-select>
                        </md-field>
                        <strong class="single-lang">
                            <span></span>
                        </strong>
                    </div>
                    <div class="el">
                        <md-field>
                            <md-select v-model="analytics.dateRange" class="half-field" placeholder="Date Range">
                                <md-option v-for="(range) in dateRanges" :value="range.value" :key="range.value">{{ range.label }}</md-option>
                            </md-select>
                        </md-field>
                    </div>
                    <div class="submit-button-el">
                        <md-button class="submit-analytics-button md-primary" @click="loadAnalytics()">Load</md-button>
                    </div>
                </div>
            </form>
        </div>

        <div v-if="isLoading" class="upload-text centered">Analyzing...
            <md-progress-spinner class="md-accent export-running-spinner" :md-diameter="30" md-mode="indeterminate"></md-progress-spinner>
        </div>

        <div>
            <router-view></router-view>
        </div>

        <md-dialog :md-click-outside-to-close="false" :md-active.sync="showDialog" class="small-modal">
            <header>
                <h2>Import Files</h2>
                <md-button class="md-icon-button" @click="closeDialog">
                    <md-icon>clear</md-icon>
                </md-button>
            </header>
            <div v-if="isUploading" class="upload-text centered">Uploading Files ...
                <md-progress-spinner class="md-accent export-running-spinner" :md-diameter="30" md-mode="indeterminate"></md-progress-spinner>
            </div>
            <div v-else-if="validationError" class="upload-text centered">
                <p>{{ validationError }}</p>
            </div>
            <md-list v-if="!isUploading && fileResults" class="scroll-list">
                <md-list-item v-for="(file, index) in fileResults" :key="file" class="line-item">
                    <div class="left-item">
                        <div class="el">{{ index }}</div>
                    </div>
                    <div class="right-item">
                        <md-button v-show="file === true" class="md-icon-button top-index">
                            <md-icon class="green-color">done</md-icon>
                        </md-button>
                        <md-button v-show="file === false" class="md-icon-button top-index">
                            <md-icon class="red-color">cancel</md-icon>
                        </md-button>
                    </div>
                </md-list-item>
            </md-list>
            <md-dialog-actions class="full-btn">
                <md-button class="md-raised md-primary" @click="closeDialog" :disabled="isUploading">close</md-button>
            </md-dialog-actions>
        </md-dialog>

        <md-dialog :md-click-outside-to-close="false" :md-active.sync="showWarningDialog">
            <header>
                <h2>Invalid Tours</h2>
                <md-button class="md-icon-button" @click="closeWarningDialog">
                    <md-icon>clear</md-icon>
                </md-button>
            </header>
            <div class="upload-text centered"><p>The following Tours have no time zone set. Please set the Time Zone property in Tour settings before importing analytics data.</p></div>
            <md-list v-if="!_.isEmpty(invalidTours)" class="scroll-list">
                <md-list-item v-for="(tour, index) in invalidTours" :key="tour.id" class="line-item">
                    <div class="left-item">
                        <div class="el">{{ tour.name }}</div>
                    </div>
                </md-list-item>
            </md-list>
            <md-dialog-actions class="full-btn">
                <md-button class="md-raised md-primary" @click="closeWarningDialog">close</md-button>
            </md-dialog-actions>
        </md-dialog>

        <md-dialog :md-click-outside-to-close="false" :md-active.sync="showClientWarningDialog">
            <header>
                <h2>Analytics Disabled</h2>
            </header>
            <div class="upload-text centered"><p>Analytics is not currently enabled for this account.</p></div>
            <md-dialog-actions class="full-btn">
                <md-button class="md-raised md-primary" @click="closeClientWarningDialog">close</md-button>
            </md-dialog-actions>
        </md-dialog>

    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';

function validateUpload (filename) {
  const fileExt = filename.trim().split('.').pop().trim().toLowerCase();
  if (fileExt !== 'sql') {
    return false;
  }

  if (filename === null || filename.length === 0 || filename.length > 70) {
    return false;
  }
}

export default {
  data () {
    return {
      allOption: 0,
      currentView: '/client/analytics/audience',
      importRunning: false,
      showDialog: false,
      showWarningDialog: false,
      showClientWarningDialog: false,
      fileNames: [],
      files: [],
      percentCompleted: 0,
      dateRanges: [
        {label: 'Last day', value: 1},
        {label: 'Last 7 days', value: 7},
        {label: 'Last 30 days', value: 30},
        {label: 'Last 60 days', value: 60},
        {label: 'Last 90 days', value: 90},
        {label: 'Last 690 days', value: 690}
      ],
      validationError: null
    };
  },
  computed: {
    ...mapGetters('analytics', {analytics: 'analytics', fileResults: 'fileResults', invalidTours: 'getInvalidTours', isLoading: 'isLoading', isUploading: 'isUploading'}),
    ...mapGetters('client', ['currentClient']),
    ...mapGetters('language', {languages: 'getLanguageList', tourLanguages: 'getTourLanguageList'}),
    ...mapGetters('routes', {routes: 'routesList'}),
    ...mapGetters('tours', ['tours']),
    showLanguageDropdown () {
      let show = false;
      if (this.$store.state.RouterModule.name === 'analyticsTopic') {
        show = true;
      }
      return show;
    }
  },
  methods: {
    ...mapActions('analytics', ['checkTimeZonesForClient', 'getAnalyticsData', 'importFiles', 'setFileResults', 'resetAnalytics']),
    ...mapActions('language', ['loadLanguageList', 'loadTourLanguageList', 'addTourLanguage', 'removeTourLanguage', 'setTourLanguageList', 'updateLanguageOrder', 'updateTourLanguages']),
    ...mapActions('routes', ['loadRoutes']),
    ...mapActions('tours', ['loadClientToursList']),
    closeDialog () {
      this.files = [];
      this.showDialog = false;
    },
    closeWarningDialog () {
      this.showWarningDialog = false;
    },
    closeClientWarningDialog () {
      this.showClientWarningDialog = false;
    },
    processFiles (evt) {
      if (this.currentClient.isAnalytics) {
        let uploads = evt.target.files;
        for (let i = uploads.length - 1; i >= 0; i--) {
          const filenameValidation = validateUpload(uploads[i].name);
          if (filenameValidation === false) {
            this.validationError = uploads[i].name + ' is invalid, please try again.';
            this.showDialog = true;
            return;
          }
          this.files.push(uploads[i]);
        }

        let config = {
          headers: {'Content-Type': 'multipart/form-data'},
          onUploadProgress: function (progressEvent) {
            this.percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            this.$forceUpdate();
          }.bind(this)
        };

        let data = new FormData();
        if (this.files.length > 0) {
          for (var i = 0; i < this.files.length; i++) {
            let file = this.files[i];
            let fileName = file.name;
            this.fileNames[i] = {fileName: fileName, result: false};
            data.append('files[]', file);
          }

          this.showDialog = true;
        }
        data.append('clientId', this.currentClient.id);
        let postData = {
          data: data,
          config: config
        };
        this.importFiles(postData);
        evt.target.form.reset();
      } else {
        this.showClientWarningDialog = true;
      }
    },
    switchView () {
      this.$router.push(this.currentView);
    },
    loadAnalytics () {
      if (this.currentClient.isAnalytics) {
        if (this.analytics.tourId === null || this.analytics.tourId === 0 || this.analytics.tourId === 'all') {
          this.analytics.routeId = null;
        }
        this.getAnalyticsData({
          clientId: this.currentClient.id,
          dateRange: (this.analytics.dateRange ? this.analytics.dateRange : 30),
          tourId: (this.analytics.tourId ? (this.analytics.tourId > 0 ? this.analytics.tourId : '') : ''),
          routeId: (this.analytics.routeId ? (this.analytics.tourId > 0 && this.analytics.routeId !== 'all' ? this.analytics.routeId : '') : ''),
          language: (this.analytics.language ? (this.analytics.language !== 'all' ? this.analytics.language : '') : '')
        });
      } else {
        this.showClientWarningDialog = true;
      }
    },
    getDropdownValues () {
      if (this.analytics.tourId !== null && this.analytics.tourId > 0) {
        this.loadLanguageList(this.analytics.tourId);
        this.loadRoutes(this.analytics.tourId);
        this.loadTourLanguageList(this.analytics.tourId);
      }
    },
    drawChart () {
      let data = new google.visualization.DataTable();
      let rows = [];
      for (let line of this.analytics.usage.chartData) {
        data.addColumn('number', line.name);
        rows.push(line.data);
        data.addRows(line.data);
      }
      let options = {
        curveType: 'function'
      };

      let chart = new google.visualization.LineChart(document.getElementById('chart'));
      chart.draw(data, options);
    },
    showWarning () {
      if (this.currentClient.isAnalytics) {
        this.showWarningDialog = true;
      } else {
        this.showClientWarningDialog = true;
      }
    }
  },
  async mounted () {
    await this.checkTimeZonesForClient(this.currentClient.id);
    this.loadClientToursList(this.currentClient.id);
    this.resetAnalytics({
      clientId: this.currentClient.id,
      tourId: null,
      routeId: null,
      language: null,
      dateRange: 30,
      usage: {
        languages: []
      }
    });
    this.loadAnalytics();
  }
};
</script>

<style type="text/css">
#analyticsTab .upload-btn {
    margin: 14px 0 14px 8px;
    color: rgba(255, 255, 255, 0.87);
    background-color: rgb(0, 168, 202);
}

#analyticsTab .upload-text {
    margin-bottom: 16px;
}

#analyticsTab .export-running-spinner {
    margin: 14px 0 14px 8px;
}

#analyticsTab .disabled-button {
    background-color: #DBDBDB;
}

#analyticsTab .spinner-container {
    width: 50px;
}

#analyticsTab .upload-btn .file-input {
    position: absolute;
    left: -15px;
    height: 100px !important;
    width: 100px;
    opacity: 0;
}

#analyticsTab .submit-analytics-button {
    background-color: #00A8CA;
    margin: 0;
}

#analyticsTab .submit-button-el {
    display: inline-block;
    padding-top: 16px;
    margin-left: 32px;
}

.md-icon.md-theme-default.md-icon-font.green-color {
    color: green !important;
}

.md-icon.md-theme-default.md-icon-font.red-color {
    color: red !important;
}

.md-list-item-text {
    padding: 0px 10px;
}

@media only screen and (max-width: 768px) {
    .float-md-left {
        float: left !important;
    }

    .float-md-left .el:first-child {
        margin-left: 0 !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/client/AnalyticsTab.vue